/**
 * pm-cart-meter.js
 * Cart drawer 运费进度条 - 动态注入版本
 * 在 ajaxCart.afterCartLoad 后注入到 .ajaxcart__inner 顶部
 */

(function () {
  'use strict';

  var THRESHOLD_CENTS = 6900;
  var METER_ID = 'pm-shipping-meter';

  function buildMeterHTML(cartTotalCents) {
    var progress = Math.min(
      Math.round((cartTotalCents / THRESHOLD_CENTS) * 100),
      100
    );
    var remaining = THRESHOLD_CENTS - cartTotalCents;

    var msg = remaining > 0
      ? 'Add <strong>$' + (remaining / 100).toFixed(2) +
        ' NZD</strong> more for free urban shipping 🚚'
      : "🎉 You've unlocked free urban shipping!";

    var msgClass = remaining > 0
      ? 'pm-shipping-meter__msg pm-shipping-meter__msg--progress'
      : 'pm-shipping-meter__msg pm-shipping-meter__msg--reached';

    return (
      '<div id="' + METER_ID + '" class="pm-shipping-meter" ' +
        'data-pm-shipping-meter ' +
        'data-threshold="' + THRESHOLD_CENTS + '" ' +
        'data-cart-total="' + cartTotalCents + '" ' +
        'aria-live="polite">' +
        '<p class="' + msgClass + '">' + msg + '</p>' +
        '<div class="pm-shipping-meter__track" ' +
          'role="progressbar" ' +
          'aria-valuenow="' + progress + '" ' +
          'aria-valuemin="0" ' +
          'aria-valuemax="100" ' +
          'aria-label="Free shipping progress">' +
          '<div class="pm-shipping-meter__fill" ' +
            'style="width:' + progress + '%" ' +
            'data-pm-meter-fill></div>' +
        '</div>' +
      '</div>'
    );
  }

  function injectOrUpdateMeter(cartTotalCents) {
    // 找到 AJAX cart items 容器（Handlebars 渲染目标）
    var cartInner = document.querySelector('.ajaxcart__inner');
    if (!cartInner) return;

    // 如果进度条已存在，更新内容
    var existing = document.getElementById(METER_ID);
    if (existing) {
      existing.outerHTML = buildMeterHTML(cartTotalCents);
      return;
    }

    // 首次注入：插在 .ajaxcart__inner 第一个子元素之前
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = buildMeterHTML(cartTotalCents);
    var meterEl = tempDiv.firstChild;

    cartInner.insertBefore(meterEl, cartInner.firstChild);
  }

  function getCartTotalAndUpdate() {
    // 从 /cart.js 拿最新 cart total（不是 Admin API）
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        injectOrUpdateMeter(cart.total_price);
      })
      .catch(function (err) {
        console.warn('[pm-cart-meter] /cart.js fetch failed:', err);
      });
  }

  // 监听原主题 AJAX cart 事件
  // vela.js 里是 body.trigger('ajaxCart.afterCartLoad', [cart])
  document.addEventListener('DOMContentLoaded', function () {
    var body = document.body;

    // jQuery 事件监听（vela.js 用 jQuery trigger）
    if (window.jQuery) {
      jQuery(body).on('ajaxCart.afterCartLoad', function (e, cart) {
        if (cart && typeof cart.total_price === 'number') {
          injectOrUpdateMeter(cart.total_price);
        } else {
          getCartTotalAndUpdate();
        }
      });
    }

    // 原生事件兜底
    body.addEventListener('ajaxCart.afterCartLoad', function (e) {
      var total = e.detail && e.detail.total_price;
      if (typeof total === 'number') {
        injectOrUpdateMeter(total);
      } else {
        getCartTotalAndUpdate();
      }
    });
  });

})();
